(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/qr-scanner/assets/javascripts/components/message-box.js') >= 0) return;  svs.modules.push('/components/tur/qr-scanner/assets/javascripts/components/message-box.js');
"use strict";

const Icon = svs.ui.ReactIcon;
const VALID_TEXT = 'Skanna och rätta lotten';
const INVALID_TITLE = 'Tyvärr är länken ogiltig';
const INVALID_TEXT = 'Det verkar som om qr-koden inte är från en av våra skraplotter. Koden kan också vara skadad.';
const Invalid = () => React.createElement("div", {
  className: "absolute padding-1 u-flex u-flex-row qr-scanner-message-box-invalid"
}, React.createElement("div", {
  className: "u-flex u-flex-align-items-center padding-right-1"
}, React.createElement(Icon, {
  className: "fc-red",
  color: "fc-red",
  icon: "exclamation-sign",
  size: "900"
})), React.createElement("div", null, React.createElement("h3", {
  className: "h3 margin-bottom-half"
}, INVALID_TITLE), React.createElement("p", null, INVALID_TEXT)));
const Correct = _ref => {
  let url = _ref.url;
  const handleClick = e => {
    e.preventDefault();
    url && svs.utils.url.navigate(url);
  };
  return React.createElement("a", {
    className: "absolute u-text-center padding-1 qr-scanner-message-box qr-scanner-message-box-info",
    href: "",
    onClick: handleClick
  }, React.createElement(Icon, {
    className: "fc-navy",
    color: "fc-navy",
    icon: "qr",
    size: "300"
  }), React.createElement("span", {
    className: "f-content f-medium margin-left-half fc-navy"
  }, VALID_TEXT));
};
setGlobal('svs.tur.qrScanner.components.MessageBox', _ref2 => {
  let message = _ref2.message,
    _ref2$invalid = _ref2.invalid,
    invalid = _ref2$invalid === void 0 ? false : _ref2$invalid,
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url;
  if (!message) {
    return null;
  }
  return invalid ? React.createElement(Invalid, null) : React.createElement(Correct, {
    url: url
  });
});

 })(window);